/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable camelcase */
import { useSelector } from 'react-redux';
import { tryDecodeJwt } from 'modules/common/helpers/jwt';
import { selectAccessToken } from 'modules/common/auth/selectors';
import { Navigate } from 'react-router-dom';
import ROUTE from 'modules/common/constants/route';
/**
 * This is use for permission handle based on the roles
 * @param {*} param0
 * @returns
 */
const PrivateRoute = ({ component: Component, roles }) => {
  /* determine if authorized, from context or however you're doing it */
  const accessToken = useSelector(selectAccessToken);
  //
  const isAuthorized = () => {
    if (accessToken && roles) {
      const user = tryDecodeJwt(accessToken);
      const tokenRoles = user?.realm_access?.roles || [];
      return roles.some((role) => tokenRoles.includes(role));
    }
    return false;
  };
  // If authorized, return an outlet that will render child elements
  // If not, return element that will navigate to login page
  if (isAuthorized()) {
    return <Component />;
  }
  //
  return <Navigate to={ROUTE.LOGIN} />;
};
//
export default PrivateRoute;
